import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import TranslationProvider from "./translations/TranslationProvider";

// console.log("[Dakika Debug] app boot", {
//   href: window.location.href,
//   nodeEnv: process.env.NODE_ENV,
// });
// console.warn("[Dakika Debug] console.warn visible check");
// console.error("[Dakika Debug] console.error visible check");

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <TranslationProvider>
      <App />
    </TranslationProvider>
  </BrowserRouter>,
);

reportWebVitals();
